<template>
  <div class="c-form-item-edit-table" :style="tableStyle">
    <CTable ref="tableRef" v-bind="innerTableAttrs">
      <template #operation="scope">
        <slot v-bind="scope" name="action">
          <el-button
            v-if="!innerTableAttrs.hideAdd"
            v-bind="innerActionAttrs"
            :disabled="!checkIsAllowAdd(scope)"
            @click="handleInsertRow(scope.$index, scope)"
          >
            +
          </el-button>
          <el-button
            v-if="!scope.row[innerTableAttrs.noRemoveRro]"
            v-bind="innerActionAttrs"
            :disabled="!checkIsAllowRemove(scope)"
            @click="handleRemoveRow(scope.$index, scope)"
          >
            -
          </el-button>
          <el-button
            v-if="innerTableAttrs.cancelPro && scope.row[innerTableAttrs.noRemoveRro]"
            v-bind="innerActionAttrs"
            @click="handleCancelRow(scope.$index, scope)"
          >
            {{ scope.row[innerTableAttrs.cancelPro] === 0 ? '添加' : '移除' }}
          </el-button>
        </slot>
      </template>
    </CTable>
  </div>
</template>

<script lang="ts">
export default { inheritAttrs: false }
</script>

<script setup lang="ts">
import { _, ref, watch, onMounted, computed, useAttrs, sizePx, useCurrentAppInstance } from '@zto/zpage'

const props = withDefaults(
  defineProps<{
    model: Record<string, any>
    prop: string
    height?: number | string
    noIndex?: boolean
    disabled?: boolean
    autoAppendFirst?: boolean // 自动添加第一行
    maxRows?: number // 最大添加条数
  }>(),
  {
    noIndex: true,
    autoAppendFirst: true
  }
)

const app = useCurrentAppInstance()
const { Message } = app.useMessage()

const attrs = useAttrs()

const tableRef = ref()

const cancelBtn = computed(status => {
  return status ? '下架' : '上架'
})

/** 表格属性 */
const innerTableAttrs = computed(() => {
  return {
    operationWidth: 110,
    ...attrs,
    disabled: props.disabled,
    editable: true,
    noPager: true,
    noIndex: props.noIndex
  }
})

const innerForm = computed(() => {
  return tableRef.value?.innerForm
})

/** 活动按钮属性 */
const innerActionAttrs = computed(() => {
  return { type: 'default' }
})

/** 表格行 */
const tableRows = computed(() => {
  return props.model[props.prop]
})

const tableStyle = computed(() => {
  const _style: any = {}
  if (props.height) {
    _style.height = sizePx(props.height)
  }
  return { ..._style }
})

watch(
  () => props.model[props.prop],
  () => {
    resetTableData()
  }
)

onMounted(() => {
  resetTableData()
})

/** 执行插入 */
function handleInsertRow(index: number, scope: any) {
  insertRow(index)
}

/** 删除行 */
function handleRemoveRow(index: number, scope: any) {
  removeRow(index)
}
/** 行数据作废 */
function handleCancelRow(index: number, scope: any) {
  setRowsDatasByKey(scope)
}
/** 是否允许删除 */
function checkIsAllowRemove(scope: any) {
  // 是否允许第一行删除
  // console.log('deletable', innerTableAttrs.value.deletable)
  if(innerTableAttrs.value.deletable === true){
    return props.disabled !== true
  }
  return scope.$index !== 0 && props.disabled !== true
}

/** 是否允许新增 */
function checkIsAllowAdd(scope: any) {
  return props.disabled !== true
}

async function resetTableData() {
  if (!tableRef.value) return

  if (props.model[props.prop] !== tableRef.value.tableData.data) {
    await tableRef.value.setData({ data: props.model[props.prop] })

    props.model[props.prop] = tableRef.value.tableData.data
  }

  if (props.autoAppendFirst && !tableRows.value?.length && !innerForm.value?.disabled) {
    appendRow()
  }
}

/** 添加空行 */
function appendRow(data?: any) {
  tableRef.value?.appendRow(data || {})
}

/** 添加空行 */
function insertRow(index: number, data?: any) {
  if (props.maxRows && tableRows.value?.length >= props.maxRows) {
    Message.warning(`最多可添加${props.maxRows}条`)
    return
  }
  tableRef.value?.insertRow(index, data)
}

/** 删除行 */
function removeRow(index: number) {
  tableRef.value?.removeRow(index)
}
/** 改变行数据属性 */
function setRowsDatasByKey(scope: any) {
  console.log(2222, scope.row)
  console.log(5555, innerTableAttrs.value.cancelPro)
  if (!innerTableAttrs.value.cancelPro) {
    new Error('请配置cancelPro属性')
    return
  }
  switch (scope.row[innerTableAttrs.value.cancelPro]) {
    case 0:
      scope.row[innerTableAttrs.value.cancelPro] = 1
      break
    case 1:
      scope.row[innerTableAttrs.value.cancelPro] = 0
      break
    case true:
      scope.row[innerTableAttrs.value.cancelPro] = false
      break
    case false:
      scope.row[innerTableAttrs.value.cancelPro] = true
      break
  }
}
const validate = () => {
  return tableRef.value?.validate()
}

defineExpose({
  innerTable: tableRef.value,
  tableRows: tableRows.value,
  checkIsAllowRemove,
  checkIsAllowAdd,
  appendRow,
  insertRow,
  removeRow,
  resetTableData,
  validate
})
</script>
